
export enum SpeciesOption {
    Option1, Option2, Option3, Option4, Option5, Option6, Option7
}